import { render, staticRenderFns } from "./GoingLive.vue?vue&type=template&id=0e069553&scoped=true"
import script from "./GoingLive.vue?vue&type=script&lang=js"
export * from "./GoingLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e069553",
  null
  
)

export default component.exports